export default __webpack_public_path__ + "static/media/IE.e593da28.svg";